// Department data for all departments
const departmentData = {
  'anatomy': {
    title: 'Department of Anatomy',
    description: 'The Anatomy department provides foundational knowledge of human body structure for medical students, including gross anatomy, histology, and embryology.',
    head: 'Dr. DABBERU RADHIKA',
    contact: 'anatomy@acsrgmc.edu.in',
    summary: 'Study of human body structure and form.'
  },
  'anaesthesiology': {
    title: 'Department of Anaesthesiology',
    description: 'THE DEPARTMENT OF ANAESTHESIOLOGY RUNNING 15 MAJOR AND MINOR OPERATION THEATRES REGULARLY AS ELECTIVE AND EMERGENCY BASED. THE DEPARTMENT REGULARLY CONDUCTING BCLS AND ACLS TRAINING PROGRAMMES TO ALL PARAMEDICAL STAFF AND NON PARAMEDICAL PEOPLE. THE HOD CONDUCTED 2 TIMES NTR UHS PG ZONAL CMES IN ACSR MEDICAL COLLEGE. ANAESTHESIOLOGY DEPARTMENT REGULARLY ORGANISING VARIOUS CRITICAL MANAGEMENT WORKSHOPS AS PER THE INSTRUCTIONS OF THE DME OFFICE.',
    head: 'Dr. M Srinivasarao',
    contact: 'anaesthesiology@acsrgmc.edu.in',
    summary: 'Expertise in anesthesia and perioperative medicine.'
  },
  'biochemistry': {
    title: 'Department of Biochemistry',
    description: 'Department of Biochemistry started from 2014 in ACSR Government Medical College, as Teaching, practical and investigations department. The full time teaching faculty educates and train students of various courses undergraduate MBBS & Nursing teaching as per NMC – CBME and YSRUHS guidelines. The clinical laboratory was also present in GGH, SPSR Nellore where it was expanded by acquiring state of art equipment and increasing the number and types of investigations performed. Since its inception, the department has flourished focusing on three core aspects: Teaching, Patient care services and Research. Currently, the tests are performed using fully automated techniques and latest methods. It present we are performing IP, OP, MCH and Aarogya sree samples around 500 samples per day investigations such as like Glucose, RFT, LFT, Lipids, Thyroids, ABG analysis and electrolytes. The central biochemistry laboratory runs 24 hours a day and all 365 days to provide emergency investigation facilities. We also followed internal and external quality control program for patient care services. Faculty and students of Biochemistry have regularly been receiving awards for their research work and publications in various National and International. Weekly patient care review and quality audit meetings are held to continuously improve upon patient care service.',
    head: 'Dr. KONDETI MADHAVI MD - Professor & HOD',
    contact: 'biochemistry@acsrgmc.edu.in',
    summary: 'Chemical basis of life and medicine.',
    hodDetails: {
      name: 'Dr. Kondeti Madhavi MBBS, M.D',
      title: 'HOD OF BIOCHEMISTRY',
      qualifications: [
        'MBBS at SV Medical College, 1992 Siddhartha Medical College',
        'MD 1999 at SV Medical College, SVMC',
        '1993-95 Residency in Endocrinology and Metabolism, SVIMS',
        '1992-93 Volunteer in Riverside Methodist Hospital, Columbus, Ohio'
      ],
      positions: [
        'Academic Council member of Dr YSRUHS library',
        'Board of studies member at Padmavati Medical College for women',
        'Ethical committee member of SPG COLLEGE OF',
        'MDRU Nodal officer 2018 to 2022in SVMC',
        'Board of studies member of Mahila University',
        'Academic member of RSSDI',
        'Cultural committee member of Dr NTR UHS'
      ],
      awards: [
        'Best Teacher award 2018',
        'Best Teacher award by IMA',
        'Best Doctor Award of Chittoor District',
        'Best Doctor Award in Covid 19 – pandemic'
      ],
      workshops: [
        'Workshop in Molecular Biology under DHR in MDRU, SVMC, Tirupati',
        'Scientific committee convener and coordinator, SVMC, Tirupati from 2018-',
        'Convener and coordinator Research Advisory Committee, MDRU and MRHRU, Tirupati from 2018-2022',
        'ICMR-DHR workshop on Strengthening of Clinical Laboratory Practices in Rural Government Hospital of SPSR Nellore, District. DHR-ICMR Workshop approved on 01.10.2023 Date of Submission: 28.06.2023, Date of Post-posed to : 18.11.2023 to 20.11.2023'
      ]
    },
    activities: [
      'Provide a unique opportunity for students to undertake core professional and research skill education.',
      'Continuous trainings are given to laboratory technical staff regarding Laboratory information system (LIS), automation, quality control and able to understand pre-analytical, analytical and post analytical procedures.',
      'Student\'s participation in all UG activates through Seminars, Group discussions and self directed learning etc is mandatory and provides training oral communication skills.',
      'ICMR workshops and UG STS projects are continuous going on in the department.'
    ]
  },
  'cardiology': {
    title: 'Department of Cardiology',
    description: 'Specializes in the diagnosis and treatment of heart and cardiovascular system disorders.',
    head: 'Dr. Manjula Meejuru',
    contact: 'cardiology@acsrgmc.edu.in',
    summary: 'Heart and cardiovascular care.'
  },
  'community-medicine': {
    title: 'Department of Community Medicine',
    description: 'Focuses on health promotion, disease prevention, and epidemiology at the community level.',
    head: 'Dr. Pothukuchi Madhavi',
    contact: 'community@acsrgmc.edu.in',
    summary: 'Public health and preventive medicine.',
    activities: [
      'Observance of National and World Health Days: like WHO days, world AIDS day, World breastfeeding week, world diabetes day, world tuberculosis day etc.',
      'Health awareness programmes/ Health education activities.',
      'Organizing Seminars, workshops, Guest Lectures and Conferences.',
      'School Health Programmes, Health check-ups of Aanganwadi children.',
      'Conducting surveys',
      'Training of students – About environment & sanitation, rural health, health programmes etc',
      'Research projects and publishing the scientific papers',
      'Participation in the national and state level conferences.',
      'Participation of staff in other programmes– like medical diagnostic camps.',
      'Participating in Rural Medical Health Camps and Outreaching programmes in Rural and Remote areas informed by the Government of Andhra Pradesh.',
      'Training of Interns who are posted in RHTC, Sangham.'
    ],
    fieldVisits: [
      'Family Health Survey',
      'Visit to PHC/RHTC',
      'Visit to sub-centre',
      'Visit to Aanganwadi (ICDS)',
      'Visit to primary school.',
      'Visit to NGO',
      'Visit to DOTS centre',
      'Visit to Leprosy centre',
      'Visit to Urban Health Centre'
    ],
    publications: {
      'Dr S Govindu': [
        'Dr S Govindu, Gopi Krishna, G. Ravi Prabhu. Prevalence of diabetes mellitus and its association with lifestyle factors among adults in Tirupati, Andhra Pradesh. IAIM, 2015; 2(5):10-17.',
        'Dr S, Govindu & B, Gopi & G., Ravi. (2015). Prevalence of diabetes mellitus among adults in tirupati and its association with certain socio – demographic factors. Journal of Evolution of Medical and Dental Sciences. 4. 4822-4828. 10.14260/jemds/2015/699.',
        'Sreenivas Naik B, Govindu S, Srinivasan K . Role of Social Implications in Endemic Fluorosis among People Living In Anantapur District, Andhra Pradesh. IOSR Journal of Dental and Medical Sciences (IOSR-JDMS) e-ISSN: 2279-0853, p-ISSN: 2279-0861.Volume 16, Issue 5 Ver. X (May. 2017), PP 09-12',
        'Sreenivas Naik B , Govindu S , Srinivasan K. A Study on the Epidemiological Aspects Among the Population Living in the Area of Endemic Fluorosis. Quest Journals Journal of Medical and Dental Science Research Volume 4~ Issue 4 (2017) pp: 05-09.',
        'Govindu, B. Gopi Krishna and G. Ravi Prabhu prevalence of diabetes mellitus and its association with obesity and hypertension among adults in Tirupati, Andhra Pradesh, India. International Journal Of Advances In Case Reports, 2015;2(8):516-520.',
        'Govindu, B. Gopi Krishna, G. Ravi Prabhu. Prevalence Of Diabetes Mellitus And Its Current Treatment Practices Among Adults In Tirupati, AP.International Journal of Current Pharmaceutical & Clinical Research e-ISSN 2248 – 9142  print-ISSN 2248 – 9134'
      ],
      'Dr.Y Venkata lakshmi': [
        'Vyshnavi K, Lakshmi YV, Kothapalle S, Subbarayudu CV, Reddy KAK. Prevalence and Risk of Reproductive Tract Infections/Sexually Transmitted Infections in Urban Slums of Tirupati – a Community Based Cross-Sectional Study. J Acad Med Pharm 2023;5(4);685-690.',
        'Amarnath Santhaseelan, Yalamanchili Venkata Lakshmi, G Kalyan Chakravarthy, G Raviprabhu4, Sowmya Pallavi Rapuri3 A cross sectional study on risk factors of road traffic accident cases admitted in a tertiary care hospital,Tirupati Int J Acad Med Pharm 2023; 5(4); 659-663'
      ],
      'Dr P Bhuvaneswari': [
        'Bhuvaneswari & M., Susmitha & P., Sujatha & K., Kiran. (2018). Prevalence of pulmonary tuberculosis among HIV seropositives attending art clinic of a tertiary care hospital, nellore, AP.. National Journal of Research in Community Medicine. 7. 220. 10.26727/NJRCM.2018.7.3.220-222.',
        'Susmitha & P., Bhuvaneswari & G., Ravi & P., Sujatha & K., Kiran. (2018). Profile of hiv-seropositive clients attending ICTC in a govt. medical college hospital, nellore.A.P.. National Journal of Research in Community Medicine. 7. 134. 10.26727/NJRCM.2018.7.2.134-137.'
      ],
      'Dr Sowmya Sudha K': [
        'Kottu, M. R., Kothapalle, S., Viswanath, A. N. K., & Gottumukkala, R. (2022). Outcome of anaemia among high-risk pregnant women in a primary health centre. International Journal Of Community Medicine And Public Health, 10(1), 159–162.',
        'Sahithi M, Sowmya Sudha K, Veesam Anantha Prakash. Assessment of status of baby friendly hospital initiative in tertiary care hospital in Tirupati. Volume – 12 | Issue – 04 | April – 2023 | PRINT ISSN No. 2277 – 8179 | DOI : 10.36106/ijsr.',
        'Pujala Sreedhar, Dr. Siva Bala Nagarajan, Dr.G.Sravana Kumar, Dr.K.Sowmya Sudha, Dr.G.Krishnababu. Tribal attitude towards malaria in east godavari district, andhra pradesh. European Journal of Molecular & Clinical Medicine. ISSN 2515-8260 Volume 10, Issue 06, 2023.',
        'Vyshnavi K, Lakshmi YV, Kothapalle S, Subbarayudu CV, Reddy KAK. Prevalence and Risk of Reproductive Tract Infections/Sexually Transmitted Infections in Urban Slums of Tirupati – a Community Based Cross-Sectional Study. J Acad Med Pharm 2023;5(4);685-690.',
        'Sowmya Sudha, Kothapalle; Amarnath Reddy, Muthukuru Chadive; Sravana Kumar, Gutta; Gandikota, Sai Nithesh; Babu, Goru Krishna. Tribal gaps in Malaria in relation to KAP in East Godavari District, Andhra Pradesh. Journal of Family Medicine and Primary Care 12(10):p 2282-2286, October 2023. | DOI: 10.4103/jfmpc.jfmpc_640_23'
      ],
      'Dr CVS Rayudu': [
        'Budala MD, Subbarayudu CV, Reddy KAK, Prabhu GR. A study on prevalence of depression and its association with sleep quality among medical undergraduates in Tirupati. IOSR-JDMS. Feb 2021; 20 (2): 01-5',
        'Chintakunta VS, Samanthapudi AV, Rapuri SP, Konda S, A MK. A cross sectional study on the assessment of physical literacy among medical students of Sri Venkateswara Medical College, Tirupati. J Evidence Based Med H Care. June 2021; 8 (23): 1882-7',
        'Kumari VR, Subbarayudu CV, RM A, Naidu CMP, Pulaganti M. A Study on Serum Magnesium in Patients Admitted in the Medical Critical Care Unit of A Tertiary Care Hospital. J Acad Med Pharm 2023;5(4);452-456',
        'Kumari VR, Subbarayudu CV, Jyothi KN, Sangeetha C, Naidu CMP. A Study On Etiology And Clinical Outcome Of Tropical  Acute Kidney  Injury (AKI) In A Tertiary  Care Hospital.Int J Acad Med Pharm 2023;5(4);436-441'
      ],
      'Dr Nagoor Khadervali': [
        'Nagoor, Khadervali; Babu, Surendra; Raziya, Dudekula. Assessment of Knowledge, Attitude, and Practices (KAP) on Menstrual Hygiene among Adolescent Girls Residing in Govt. Social Welfare Hostels. D Y Patil Journal of Health Sciences 9(2):p 46-50, Apr–Jun 2021. | DOI: 10.4103/dypj.dypj_36_21'
      ],
      'Dr Saleha Afreen': [
        'Saleha Afreen, Vidhya Wilson, Surendranath Sai. "A study on prevalence of reproductive tract infections and health seeking behaviour among the women in an urban slum area of Karimnagar". Perspectives in Medical Research. 2020; 8(1):29-33'
      ],
      'Dr S. S. N. Kowmudi': [
        'Chinnamma, G.V.Phani kumar ,S. Sivanaga Kowmudi "Readiness for Self- directed Learning among Undergraduate Medical Students of Guntur Medical College, Guntur." IOSR Journal of Dental and Medical Sciences (IOSR JDMS), 19(7), 2020, pp. 32-36.',
        'S. N. Kowmudi, P. Radhakumari and R. Nageswara Rao. "Comparison of perception on education among fifth and seventh semester medical students in a government medical college, Guntur." WORLD JOURNAL OF PHARMACEUTICAL AND MEDICAL RESEARCH. wjpmr, 2021,7(9), 225 – 228.'
      ],
      'Dr Vyshnavi Kancherla': [
        'Vanajakshamma Velam, Vyshnavi Kancherla, Latheef Kasala, Anusha Kancherla, Mounica Reddy Pillaram. "Gender-Wise Comparative Assessment of Lifestyle Patterns and Well-Being Status among Healthcare Employees at a Tertiary Care Hospital." Ind J Car Dis Wom 2021;6:1–5.'
      ],
      'Dr Rajasekhar T': [
        'Rajasekhar T, Naveen KHS, Raghav P, Aneja J, Thirunavukkarasu P, Dutta G, Srinivasan S, Sharma PP, Gupta MK, Goel AD. "Exploring internet addiction and its associated factors among college students in Western Rajasthan, India: A mixed-methods study." Indian J Psychiatry. 2023 Aug;65(8):839-852.'
      ]
    },
    ongoingResearchProjects: [
      'Dr S Govindu, Dr Y Bhavani, Dr P Sasikala; Dr S Pravallika; Morbidity Profile of Children from Birth to 18 Years of Age Referred for Intervention to the District Early Intervention Centre in a District Hospital, Andhra Pradesh',
      'Dr Y Bhavani, A Study of Knowledge Attitude and practice about covid vaccination among rural & urban population.',
      'Dr Y Bhavani, Dr S Pravallika; A Study of Acute respiratory among 1 to 5 years children at tertiary care hospital, Andhra Pradesh.',
      'Dr Nagoor Khadervali; A Study of Knowledge Attitude and practice about covid vaccination among rural & urban population.',
      'Dr Nagoor Khadervali; Dr.P.Sasikala; Migraine and Associated disability among undergraduate medical students of a tertiary care teaching medical college and hospital in Nellore city – across a sectional study.',
      'Dr.S.Pravallika, Menstrual Cup awareness and acceptance among reproductive age women in an urban area of Andhra Pradesh.',
      'Dr.P.Sasikala; Dr.Saleha Afreen; A Study on Breast feeding activities in rural areas of Nellore district.',
      'Dr.Saleha Afreen; A Study on adverse effects of Covaxin and occurrence of COVID infection among vaccinated.',
      'Dr S Govindu acting as Guide to Dr. Rakesh Bolisetty, Post Graduate for the research project entitled "Research project entitled "Cardiovascular disease risk assessment among adult population in rural field practice of a government medical college Nellore AP" which is a self funded research project.',
      'Dr Y Venkata Lakshmi acting as Guide to Dr. Baby Shalini, Post Graduate for the research project entitled "Prevalence of Refractive errors and its associated risk factors among secondary school children, in urban city of Nellore " which is a self funded research project.'
    ],
    outreachActivities: [
      'Jagan Anna Arogya Suraksha (JAAS) medical health camps in Tribal and Rural areas',
      'Family health surveys as part of training of MBBS students in rural field Practice area of RHTC, Sangam.',
      'SWASTHYA VIDYA VAHINI(SVV) programme was conducted in various villages.',
      'Family Doctor Program (FDP) at RHC, Sangam in August, 2023.',
      'Family Doctor Program (FDP) at PHC, Allipuram in July, 2023.',
      'Tuberculosis survey monitoring as part of SNC in January, 2023.',
      'COVID-19 Vaccination programme in January 2021 at ACSR GMC, Nellore coordinated by Nodal Officer Dr.S Govindu Professor and Head of Community Medicine, ACSR GMC, Nellore.',
      'Monitoring of National Immunization Drive in Rural & Urban areas of Nellore District March, 2023.'
    ],
    workshopsCME: [
      'Conducted seminar competition on World Breastfeeding Week – A key to sustainable development challenges and interventions at local level on 04-08-2016.',
      'Commemorated World AIDS Day on 01.12.2022.',
      'Attended IAPSM conference SPM at Vijayawada – 2022. Paper presentation by Dr Saleha Afreen.',
      'Organized CME on World Tuberculosis Day on 24.03.2023 with collaboration of Microbiology,Pathology, Pharmacology, Pulmonary Medicine.',
      'International conference on neuroscience and role of primary care physician on 30.07.2023.',
      'International conference on emergency medicine and role of primary care physician on 24.09.2023',
      '39th International conference on endocrinology and role of primary care physicians Webinar on 22.10.2023 attended by Dr P Sasikala.',
      'Dr T Rajasekhar attended the Indian Society of Lifestyle Medicine conference in Chennai in 2023.',
      'Attended A National Workshop On Systematic Review & Meta Analysis Oct-14- 2023 [Hybrid mode] on Oct 14, 2023.'
    ],
    ruralHealthCentre: {
      title: 'Rural Health Centre',
      description: 'Rural Health Centre is located 30 kms away from ACSR medical college. RHTC Caters rural slum population of 60000. The villages covered by RHTC.',
      activities: [
        'Health care activities.',
        'Diagnosis treatment of minor elements free of cost. Average daily OPD is 100-120.',
        'ANC Clinic:- on every Wednesday – Registration of ANC cases, health check up and immunization of mothers.',
        'Immunization Clinic : On every Wednesday. Immunization of children against vaccine preventable diseases and immunization of mothers.',
        'Health education is provided to all OPD cases and to the community about nutrition, hygiene, environmental sanitation and infectious disease prevention and also at the time of awareness day programme.',
        'Family Planning: – Distribution of oral contraceptive pills, condoms. Motivation of eligible couples for tubectomy and vasectomy.',
        'Teaching activities: – Family health survey, clinical postings, medico social case study for the under graduate students. To acquaint the students for the rural health and functioning of RHTC.',
        'Maintenance of records :- like OPD register, ANC Register, PNC Register, Immunization Register, Health Education register, School health Check Register etc.',
        'Celebration of National Health Days:- Like World AIDS Day, WHO Day, World breast feeding week, World Diabetes Day, World TB Day etc.',
        'Referral Services :- Referral of cases those who need investigations, hospitalization etc.'
      ]
    },
    urbanHealthCentre: {
      title: 'Urban Health Centre',
      description: 'Urban Health Centre is situated at UCO nagar, 4 kms away from ACSR, NELLORE. The total population covered by UHC is 45,000.',
      activities: [
        'OPD Services:- Daily OPD 100-120',
        'Laboratory services',
        'Health Education',
        'Eye care services :- like cataract surgeries, refractive errors, treatment of other eye conditions.',
        'Family Planning Services.',
        'Celebration of National Health Days.',
        'Referral services.'
      ]
    }
  },
  'dentistry': {
    title: 'Department of Dentistry',
    description: 'Provides comprehensive dental education and care, focusing on oral health and dental procedures.',
    head: 'Dr. Madavala Hima Bindu',
    contact: 'dentistry@acsrgmc.edu.in',
    summary: 'Oral health and dental care.'
  },
  'dermatology': {
    title: 'Department of Dermatology',
    description: 'Specializes in the diagnosis and treatment of skin conditions and disorders.',
    head: 'Dr. JCHKLP Kishore',
    contact: 'dermatology@acsrgmc.edu.in',
    summary: 'Skin care and treatment.'
  },
  'dvl': {
    title: 'Department of Dermatology, Venereology & Leprosy',
    description: 'Specializes in the diagnosis and treatment of skin conditions, sexually transmitted diseases, and leprosy.',
    head: 'Dr. Jukunta Ch K L P Kishore',
    contact: 'dvl@acsrgmc.edu.in',
    summary: 'Skin, STD, and leprosy care.'
  },
  'emergency-medicine': {
    title: 'Department of Emergency Medicine',
    description: 'Provides immediate medical care for acute illnesses and injuries, training future emergency physicians.',
    head: 'Dr. Yallanti Gangadharam',
    contact: 'emergency@acsrgmc.edu.in',
    summary: 'Acute and emergency care.'
  },
  'ent': {
    title: 'Department of ENT (Otorhinolaryngology)',
    description: 'Specializes in the diagnosis and treatment of ear, nose, throat, and related head and neck disorders.',
    head: 'Dr. Killu Sri Devi',
    contact: 'ent@acsrgmc.edu.in',
    summary: 'Ear, nose, and throat care.'
  },
  'forensic-medicine': {
    title: 'Department of Forensic Medicine',
    description: 'Deals with the application of medical knowledge to legal issues and investigations.',
    head: 'Dr. Bandameedi Lakshmi Narayana',
    contact: 'forensic@acsrgmc.edu.in',
    summary: 'Medicine and law interface.'
  },
  'general-medicine': {
    title: 'Department of General Medicine',
    description: 'Provides comprehensive medical care and education in internal medicine and its subspecialties.',
    head: 'Dr. NADIGOTLA VIKRAM ALI BENHUR',
    contact: 'medicine@acsrgmc.edu.in',
    summary: 'Comprehensive internal medicine.'
  },
  'general-surgery': {
    title: 'Department of General Surgery',
    description: 'Offers surgical education and training, covering a wide range of surgical procedures and techniques.',
    head: 'Dr. Yarram Rajya Lakshmi',
    contact: 'surgery@acsrgmc.edu.in',
    summary: 'Surgical care and education.'
  },
  'hospital-administration': {
    title: 'Department of Hospital Administration',
    description: 'Manages hospital operations and healthcare delivery systems to ensure efficient patient care.',
    head: 'Dr. V Kalarani',
    contact: 'admin@acsrgmc.edu.in',
    summary: 'Healthcare management.'
  },
  'mch-neuro-surgery': {
    title: 'Department of Neurosurgery',
    description: 'Specializes in surgical treatment of disorders affecting the nervous system, brain, and spine.',
    head: 'Dr. Jonnalagadda V V N Dheeraj',
    contact: 'neurosurgery@acsrgmc.edu.in',
    summary: 'Surgical care of nervous system.'
  },
  'mch-surgical-oncology': {
    title: 'Department of Surgical Oncology',
    description: 'Focuses on surgical management of cancer, providing comprehensive cancer care and education.',
    head: 'Dr. Arumulla Jahnavi',
    contact: 'oncology@acsrgmc.edu.in',
    summary: 'Cancer surgery and care.'
  },
  'microbiology': {
    title: 'Department of Microbiology',
    description: 'Studies microorganisms and their role in human disease, diagnosis, and prevention.',
    head: 'Dr. Chalamcherla Srinivasa Rao',
    contact: 'microbiology@acsrgmc.edu.in',
    summary: 'Microbes and infectious diseases.'
  },
  'neurology': {
    title: 'Department of Neurology',
    description: 'Specializes in the diagnosis and treatment of disorders of the nervous system.',
    head: 'Dr. Perepu Phani Kumar',
    contact: 'neurology@acsrgmc.edu.in',
    summary: 'Nervous system disorders.'
  },
  'obstetrics-gynaecology': {
    title: 'Department of Obstetrics & Gynaecology',
    description: 'Provides comprehensive care for women\'s reproductive health and pregnancy.',
    head: 'Dr. I Indira',
    contact: 'obgyn@acsrgmc.edu.in',
    summary: 'Women\'s health and pregnancy care.'
  },
  'ophthalmology': {
    title: 'Department of Ophthalmology',
    description: 'Specializes in eye care, vision problems, and treatment of eye diseases.',
    head: 'Dr. Dasari Satya Vardhana Rao',
    contact: 'eye@acsrgmc.edu.in',
    summary: 'Eye care and vision health.'
  },
  'orthopedics': {
    title: 'Department of Orthopaedics',
    description: 'Focuses on musculoskeletal system disorders and their treatment.',
    head: 'Dr. KONATHAM BHASKAR',
    contact: 'ortho@acsrgmc.edu.in',
    summary: 'Bone and joint care.'
  },
  'paediatrics': {
    title: 'Department of Paediatrics',
    description: 'Provides comprehensive healthcare for infants, children, and adolescents.',
    head: 'Dr. Akula Venkata Rama Kishore',
    contact: 'pediatrics@acsrgmc.edu.in',
    summary: 'Child healthcare.'
  },
  'pathology': {
    title: 'Department of Pathology',
    description: 'Studies diseases and their effects on body tissues and systems.',
    head: 'Dr. BHARATALA VENKATA SAI PRASAD',
    contact: 'pathology@acsrgmc.edu.in',
    summary: 'Disease diagnosis and study.'
  },
  'pharmacology': {
    title: 'Department of Pharmacology',
    description: 'Studies drugs and their effects on biological systems.',
    head: 'Dr. KONDUGARI CHENCHU RADHIKA RANI',
    contact: 'pharmacology@acsrgmc.edu.in',
    summary: 'Drug studies and therapeutics.'
  },
  'physiology': {
    title: 'Department of Physiology',
    description: 'Studies the functions and mechanisms of living organisms.',
    head: 'Dr. Vakalapudi Sujatha',
    contact: 'physiology@acsrgmc.edu.in',
    summary: 'Body functions and mechanisms.'
  },
  'psychiatry': {
    title: 'Department of Psychiatry',
    description: 'Focuses on mental health disorders and their treatment.',
    head: 'Dr. Pathapati Lakshmi Prasuna',
    contact: 'psychiatry@acsrgmc.edu.in',
    summary: 'Mental health care.'
  },
  'pulmonary-medicine': {
    title: 'Department of Respiratory Medicine',
    description: 'Specializes in diseases of the respiratory system.',
    head: 'Dr. G ARUNA',
    contact: 'respiratory@acsrgmc.edu.in',
    summary: 'Respiratory system care.'
  },
  'radio-diagnosis': {
    title: 'Department of Radio Diagnosis',
    description: 'Provides diagnostic imaging services and interpretation.',
    head: 'Dr. D Dhanalaxmi',
    contact: 'radiology@acsrgmc.edu.in',
    summary: 'Medical imaging and diagnosis.'
  },
  'radiation-oncology': {
    title: 'Department of Radiation Oncology',
    description: 'Specializes in radiation therapy for cancer treatment.',
    head: 'Dr. GUDE HARIPRIYA',
    contact: 'radiotherapy@acsrgmc.edu.in',
    summary: 'Radiation therapy for cancer.'
  },
  'transfusion-medicine': {
    title: 'Department of Transfusion Medicine',
    description: 'Manages blood transfusion services and blood banking.',
    head: 'Dr. Madithadu Anitha',
    contact: 'transfusion@acsrgmc.edu.in',
    summary: 'Blood banking and transfusion.'
  },
  'urology': {
    title: 'Department of Urology',
    description: 'Specializes in the diagnosis and treatment of disorders of the urinary system and male reproductive organs.',
    head: 'Dr. Juturu Jayaraju',
    contact: 'urology@acsrgmc.edu.in',
    summary: 'Urinary system and male reproductive care.'
  }
};

export default departmentData; 